import React, { useEffect, useRef, useState } from "react";
import { Controller, useForm } from "react-hook-form";
import SelectBox from "../../../../components/elements/form/selectBox";
import Input from "../../../../components/elements/form/input";
import Label from "../../../../components/elements/form/fromLabel";
import Button from "../../../../components/elements/button";
import Loader from "../../../../components/loader";
import { useVendorsApi } from "../../../../store/api/hooks/vendorsApiHook";
import { useSpearPartsApi } from "../../../../store/api/hooks/spearPartsApiHook";
import toast from "react-hot-toast";

interface CreatePreferredVendorProps {
    parts: any;
    data: any;
    onCreate?: (data: any) => void;
    onCancel?: () => void;
}
type FormValues = {
    partsID: any;
    vendorPartCode: any;
    vendorID: any;
    costPerUnit: any;
};

const CreatePreferredVendor: React.FC<CreatePreferredVendorProps> = ({ parts, data, onCreate = (data: any) => { }, onCancel = () => { } }) => {
    const vendorsApi = useVendorsApi();
    const partsApi = useSpearPartsApi();

    const { control, register, handleSubmit, setValue, watch, formState: { errors }, reset } = useForm<FormValues>();

    const [loading, setLoading] = useState<boolean>(false);
    const [vendorList, setVendorList] = useState<any>([]);

    const isEditMode = data !== null;
    console.log("data in preferred vendor modal", data);

    const init_page_data = async () => {

        setLoading(true);
        const purchasingVendorResp = await new Promise((resolve, reject) => {
            vendorsApi.FilteredServiceProviderList({
                vendorIDs: [],
                vendorServiceTypeIDs: [6],
                vendorServiceTypeExcludeIDs: [],
                partsIDs: [],
                searchParam: ``
            }, (resp: any) => {
                
                if (resp && resp.hasOwnProperty(`successful`) && resp.successful && resp.hasOwnProperty(`vendorList`) && Array.isArray(resp.vendorList) && resp.vendorList.length > 0) {
                    const vendorData = resp.vendorList.map((vendor: any) => ({
                        value: vendor.vendorID,
                        label: vendor.name
                    }));
                    resolve(vendorData);
                } else {
                    reject([]);
                }
                
                /*
                if (resp && resp.hasOwnProperty(`successful`) && resp.successful && resp.hasOwnProperty(`vendorFileList`) && Array.isArray(resp.vendorFileList) && resp.vendorFileList.length > 0) {
                    const data = resp.vendorFileList.map((vendor: any) => ({
                        value: vendor.vendorID,
                        label: vendor.name
                    }));
                    resolve(data);
                } else {
                    reject([]);
                }
                */              
            }, (error: any) => {
                reject([]);
            });
        }).catch((error: any) => {
            console.error("Error fetching vendors:", error);
            return [];
        });
        setVendorList(purchasingVendorResp);
        
        // Pre-fill form if in edit mode
        if (data && Array.isArray(purchasingVendorResp)) {
            const selectedVendor = (purchasingVendorResp as any[]).find((v: any) => v.value === data.vendorID);
            if (selectedVendor) {
                setValue('vendorID', selectedVendor);
            }
            setValue('vendorPartCode', data.vendorPartCode || '');
            setValue('costPerUnit', data.costPerUnit || '');
        }
        
        setLoading(false);
        console.log("purchasingVendorResp", purchasingVendorResp);
    }

    const onSubmit = async (formData: FormValues) => {
        console.log("formData", formData);
        const payload:any = {
            partsID: parts?.partsID,
            vendorID: formData.vendorID && typeof formData.vendorID !== undefined && formData.vendorID.hasOwnProperty(`value`) ? formData.vendorID.value : null,
            isPreferred: isEditMode ? data.isPreferred : false,
            vendorPartCode: formData.vendorPartCode,
            costPerUnit: +formData.costPerUnit
        };
        
        // Only check for duplicate vendor in create mode
        if (!isEditMode && parts.vendors && Array.isArray(parts.vendors) && parts.vendors.length > 0) {
            const existingVendor = parts.vendors.find((vendor: any) => +vendor.vendorID === +payload.vendorID);
            if (existingVendor) {
                toast.error(`Vendor already exists for this part`);
                return;
            }
        } else {
            payload.partsVendorMapID = data.partsVendorMapID;
        }
        console.log("Final payload is -> ", payload);
        setLoading(true);
        const vendorresp: any = await new Promise((resolve, reject) => {
            partsApi.SavePartsVendorMap(payload, (respData: any) => {
                resolve(respData);
            }, (error: any) => {
                reject(error);
            });
        }).catch((error: any) => {
            console.error("Error saving vendor map:", error);
            return null;
        });
        setLoading(false);
        if (vendorresp && vendorresp.hasOwnProperty(`successful`) && vendorresp.successful) {
            toast.success(vendorresp.message || (isEditMode ? `Vendor Updated Successfully` : `Vendor Added Successfully`));
            onCreate(null);
        } else {
            toast.error(vendorresp.message || (isEditMode ? `Failed to Update Vendor` : `Failed to Add Vendor`));
        }
    };

    useEffect(() => {
        init_page_data();
    }, [data]);

    return (
        <div className={`relative min-h-[359px]`}>
            {loading && <div className={`absolute inset-0 z-20 bg-white flex items-center justify-center`}><Loader /></div>}
            <div className={`${loading ? `hidden` : ``}`}>
                <h4 className={`font-bold text-lg pl-0 pr-0 mb-4 modal-header`}>{isEditMode ? 'Edit Preferred Vendor' : 'Create Preferred Vendor'}</h4>
                <form onSubmit={handleSubmit(onSubmit)}>
                    <Controller
                        name='vendorID'
                        control={control}
                        rules={{ required: 'Vendor Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <SelectBox
                                label='Vendor'
                                value={value}
                                onChange={onChange}
                                placeholder='Choose Vendor'
                                className='mt-0'
                                required
                                options={vendorList}
                                error={errors.vendorID?.message as any}
                                disabled={isEditMode}
                            />
                        )}
                    />

                    <Controller
                        name='vendorPartCode'
                        control={control}
                        //rules={{ required: 'Vendor Part Code Reuired' }}
                        render={({ field: { value, onChange } }) => (
                            <Input
                                label='Vendor Part Code'
                                type='text'
                                value={value}
                                onChange={onChange}
                                // required
                                placeholder='Write Vendor Part Code Here'
                                error={errors.vendorPartCode?.message as any}
                            />
                        )}
                    />

                    <div className={`my-6`}>
                        <p className={`font-normal text-[0.938rem] leading-none`}>Cost per Unit</p>
                        <div className={`flex`}>
                            <div className={`pt-2`}><span className={`font-semibold w-9 border border-gray-200 bg-gray-50 h-[46px] flex items-center justify-center rounded-tl-md rounded-bl-md border-r-0`}>$</span></div>
                            <Controller
                                name="costPerUnit"
                                control={control}
                                // rules={{ required: 'Cost Per Unit Required' }}
                                render={({ field: { value, onChange } }) => (
                                    <Input
                                        label={``}
                                        type="number" // keep as text to allow decimal typing
                                        value={value}
                                        onChange={onChange}
                                        placeholder="0.00"
                                        error={errors.costPerUnit?.message as any}
                                        className={`text-right !rounded-md !border-gray-300 w-full !my-0`}
                                        mainELclassName="input-no-spinner"
                                    />
                                )}
                            />
                        </div>
                    </div>
                    <div className={`flex justify-end gap-2`}>
                        <Button type="button" theme={`secondary`} onClick={() => {
                            onCancel();
                        }}>Cancel</Button>
                        <Button type="submit">Submit</Button>
                    </div>
                </form>
            </div>
        </div>
    )
};

export default CreatePreferredVendor;   